import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Application } from '@models';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  private http = inject(HttpClient);

  create(name: string, endpoints: string[], validUntil?: Date) {
    return this.http.post<Application>(
      `${environment.komainuHost}/application/`,
      {
        name: name,
        endpoints: endpoints,
        validUntil: validUntil || null,
      } as Application,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      },
    );
  }

  read(id: string) {
    return this.http.get<Application>(
      `${environment.komainuHost}/application/${id}`,
    );
  }

  list() {
    return this.http.get<Application[]>(
      `${environment.komainuHost}/application/`,
    );
  }

  update(
    id: string,
    name: string,
    endpoints: string[],
    validUntil?: Date,
  ) {
    return this.http.put<Application>(
      `${environment.komainuHost}/application/${id}`,
      {
        name: name,
        endpoints: endpoints,
        validUntil: validUntil || null,
      } as Application,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      },
    );
  }

  delete(id: string) {
    return this.http.delete<void>(
      `${environment.komainuHost}/application/${id}`,
    );
  }
}
